{
  "title": "Account Management",
  "account": "Account",
  "name": "Name",
  "changeName": "Change Name",
  "changeNameIcon": "fa-solid fa-user-pen",
  "oSecret": "Old Password",
  "nSecret": "New Password",
  "changeSecret": "Change Password",
  "changeSecretIcon": "fa-solid fa-pen-to-square",
  "oSecretPlaceholder": "Enter old password to change details",
  "nSecretPlaceholder": "Enter new password to change password",
  "wrongSecret": "Incorrect password",
  "changed": "Updated successfully"
}